declare const window: any;

export default class Map {
    private selector: HTMLElement;

    constructor(selector: string) {
        this.selector = document.querySelector(selector);
        if (this.selector) {
            this.init();
        }
    }

    private init(): void {
        this.appendScript();
    }

    private appendScript(): void {
        const script: HTMLScriptElement = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${window.key}&callback=init`;
        document.body.appendChild(script);
    }
}

window.init = () => {
    const infowindows = [];
    const markers = [];
    const encodedSvg: string = encodeURIComponent('<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56"><g clip-path="url(#clip0)"><path d="M28 0C16.422 0 7 9.487 7 21.152c0 16.573 19.026 33.686 19.836 34.405a1.757 1.757 0 002.329.002C29.973 54.838 49 37.725 49 21.152 49 9.487 39.578 0 28 0zm0 32.667c-6.433 0-11.667-5.234-11.667-11.667S21.567 9.333 28 9.333 39.667 14.567 39.667 21 34.433 32.667 28 32.667z" fill="#F15A38"/></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h56v56H0z"/></clipPath></defs></svg>');
    const map = new window.google.maps.Map(document.querySelector('#map'), {
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false,
        fullscreenControl: false,
        zoomControl: true,
        clickableIcons: false,
        center: {
            lat: window.lat,
            lng: window.lng,
        },
        styles: [
            {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#d3d3d3',
                    },
                ],
            },
            {
                featureType: 'transit',
                stylers: [
                    {
                        color: '#808080',
                    },
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#b3b3b3',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#ffffff',
                    },
                    {
                        weight: 1.8,
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#d7d7d7',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#ebebeb',
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#a7a7a7',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#efefef',
                    },
                ],
            },
            {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#696969',
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#737373',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: 'd6d6d6',
                    },
                ],
            },
            {
                featureType: 'road',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {},
            {
                featureType: 'poi',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#dadada',
                    },
                ],
            },
        ],
        zoom: window.zoom,
    });

    window.pins.forEach((pin) => {
        const marker = new window.google.maps.Marker({
            map,
            draggable: false,
            position: new window.google.maps.LatLng(pin.lat, pin.lng),
            icon: {
                url: `data:image/svg+xml;charset=utf-8,${encodedSvg}`,
                scaledSize: new window.google.maps.Size(56, 56),
            },
        });

        const infowindow = new window.google.maps.InfoWindow({
            content: `<span class="map__icon-text">${pin.text}</span>`,
        });

        infowindows.push(infowindow);
        markers.push(marker);

        marker.addListener('click', () => {
            infowindows.forEach((item) => {
                item.close();
            });
            infowindow.open(map, marker);
        });

        map.addListener('click', () => {
            infowindow.close();
        });
    });
};
